import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';

/** Espace personnel : réservé aux comptes société qui ont aussi une fiche ressource. */
export const personalSpaceGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    return authService.hasPersonalSpace() || inject(Router).parseUrl('/access-denied');
};
